import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var ArrowForward = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    d: "M13 5.499a.996.996 0 00-1 1v2.559c-4.5.498-8 4.309-8 8.941v1c2.245-3.423 5.25-3.92 8-3.989v2.489a.999.999 0 001.707.707L20 11.999l-6.293-6.208A.996.996 0 0013 5.499z",
    key: "k0"
  }));
});
ArrowForward.displayName = 'ArrowForward';
export var ArrowForwardDimensions = {
  height: 24,
  width: 24
};